import { Auth, Config, Login } from "@cleeng/mediastore-sdk";
import axios from "axios";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { API_URL, NODE_ENV, PUBLISHER_ID } from "../../../constants";
import { axiosConfig, setCookie } from "../../../utils";

Config.setPublisher(PUBLISHER_ID);
Config.setEnvironment(NODE_ENV);
function LoginPage() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const redirectApp = query.get("redirect");

  const handleNavigate = (path) => {
    return () => navigate(path);
  };
  useEffect(() => {
    if (Auth.isLogged()) {
      if (redirectApp === "app") {
        window.open("https://app.supersimple.com/check_login", '_self');
        return
      }
      navigate("/choose-plan");
    }
    Config.setPublisher(PUBLISHER_ID);
    Config.setEnvironment(NODE_ENV);
    // eslint-disable-next-line
  }, []);
  const handleSuccess = async () => {
    const res = await axios.get(
      `${API_URL}/customers/${localStorage.getItem(
        "CLEENG_CUSTOMER_ID",
      )}/transactions?limit=1`,
      axiosConfig(),
    );
    const resOffer = await axios.get(
      `${API_URL}/customers/${localStorage.getItem(
        "CLEENG_CUSTOMER_ID",
      )}/offers`,
      axiosConfig(),
    );

    setCookie("token", localStorage.getItem("CLEENG_AUTH_TOKEN"));
    setCookie("refreshToken", localStorage.getItem("CLEENG_REFRESH_TOKEN"));
    setCookie("customerId", localStorage.getItem("CLEENG_CUSTOMER_ID"));

    const items = (res.data && res.data.responseData.items) || [];
    const offerItems = (resOffer.data && resOffer.data.responseData.items) || []

    let redirect = localStorage.getItem("save_redirect_url");

    if (redirect) {
      navigate(redirect);
      localStorage.removeItem("save_redirect_url");
      return
    } else if (items.length && offerItems.length) {
      const [offer] = offerItems;
      const isValid = offer && (offer.expiresAt * 1000) > Date.now();

      if (redirectApp === "app" && isValid) {
        window.open("https://app.supersimple.com/check_login", '_self');
        return;
      }

      if (['android', 'ios'].includes(items[0].paymentMethod)) {
        navigate(`/manage-account?platform=${items[0].paymentMethod}`);
        return
      }

      navigate("/my-account");
      return;
    }

    navigate("/choose-plan");
  };
  return (
    <>
      <Login
        onSuccess={handleSuccess}
        onRegisterClick={handleNavigate("/register")}
        onPasswordResetClick={handleNavigate("/password-reset")}
      />
    </>
  );
}

export default LoginPage;
